import { AT_ARCHIVE_LOADED, IArchiveLoadedAction } from './types';

export const archiveLoadedAction = (
    isArchiveLoaded: boolean
): IArchiveLoadedAction => {
    return {
        type: AT_ARCHIVE_LOADED,
        isArchiveLoaded,
    }
};
